/**
 * @description 旅平險商品方案用
*/
export enum TravelPlanType {
  /** 特定活動 */
  SPI = 'SPI',
  /** 國內旅遊 */
  Domestic = 'NTD',
  /** 國外旅遊 */
  Abroad = 'NTA',
  /** 申根保險 */
  NTAG = 'NTAG',
  /** 登山保險 */
  MPA = 'MPA',
  /** 旅遊泡泡 */
  TBP = 'TBP',
  WPA = 'WPA'
}

export enum PlanType {
  /** 自由選 PlanId */
  Free = 'AP3',
  /** 車險保障內容含保障項目，方案類型-一般 */
  Normal = 'A',
  /** 車險保障內容含保障項目，方案類型-自由選 */
  FreePlan = 'F',
  /** 車險保障內容含保障項目，方案類型-電動車專用 */
  Electric = 'E'
}
